export function createAuthGuards({ store }) {
  async function ensureAuth(to, from, next, redirectIfLogged = false) {
    if (store.getters.isAuthenticated) {
      return next(redirectIfLogged ? "/dashboard" : undefined);
    }

    if (!store.state.authChecked) {
      try {
        await store.dispatch("tryRestoreSession");
      } catch (e) {
        // ignore
      }
    }

    const isLogged = store.getters.isAuthenticated;
    const protectedRoute = isProtectedRoute(to);

    if (isLogged) {
      return next(redirectIfLogged ? "/dashboard" : undefined);
    }

    if (redirectIfLogged) {
      return next();
    }

    if (protectedRoute) {
      return next("/login");
    }

    return next();
  }

  const middlewareAuth = (to, from, next) => ensureAuth(to, from, next);
  const middlewareGuest = (to, from, next) => ensureAuth(to, from, next, true);

  function isProtectedRoute(to) {
    return to.matched.some((r) => r.meta?.requiresAuth === true);
  }

  const ensureRole =
    (allowedRoles = []) =>
    (to, from, next) => {
      const role = store?.state?.user?.adminRole;
      if (allowedRoles.includes(role)) return next();
      return next({ name: "NotFound" });
    };

  const middlewareStoreAdmin = ensureRole(["owner", "dev", "adm"]);

  return {
    ensureAuth,
    middlewareAuth,
    middlewareGuest,
    isProtectedRoute,
    ensureRole,
    middlewareStoreAdmin,
  };
}
